<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <div class="container-fluid mt--8">
            <div class="card shadow">
                <div class="row p-3">
                    <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
                        <button v-on:click="showConfirmationModal = true" :disabled="!showActionDelete"
                            class="btn btn-danger">
                            <i class="fa fa-trash"></i> Delete
                        </button>
                        <button v-on:click="onEditRow" :disabled="!showActionEdit" class="btn btn-primary">
                            <i class="fa fa-edit"></i> Edit
                        </button>
                        <button v-on:click="onCreateNewPromoter" class="btn btn-primary">
                            Create Promoter
                        </button>
                        <button v-on:click="onImportPromoter" class="btn btn-primary">
                            Import Promoter
                        </button>
                    </div>
                    <div class="col-6 pull-right">
                        <div class="row">
                            <label class="col-4 col-form-label form-control-label text-right">
                                Brand
                            </label>
                            <div class="col-8">
                                <model-list-select :list="brandCodeOption" v-model="watch_brand_code" option-value="value"
                                    option-text="text" placeholder="Select Brand">
                                </model-list-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="message">
                    <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{
                        message.message
                    }}</base-alert>
                </div>
                <div v-if="deleteMessages">
                    <base-alert :type="deleteMessages[0].type" :dismissible="true" v-for="(row, index) in deleteMessages"
                        :key="index">{{ row.message }}</base-alert>
                </div>
                <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes"
                    @on-select-row="onSelectRow" @on-unselect-row="onSelectRow" @refresh-data="onRefreshData">
                </vue-bootstrap4-table>
            </div>
        </div>
        <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
            <h3>Are you sure to delete these items?</h3>
            <ul>
                <li v-for="(row, index) in selectedItems" :key="index">
                    {{ row.promoter_code }}
                </li>
            </ul>
            <template slot="footer">
                <div class="row">
                    <div class="col-lg-6">
                        <base-button type="link" class="ml-auto btn-block" @click="showConfirmationModal = false">No
                        </base-button>
                    </div>
                    <div class="col-lg-6">
                        <base-button type="primary" class="ml-auto btn-block" @click="onDeleteRow">Yes
                        </base-button>
                    </div>
                </div>
            </template>
        </modal>
        <modal :show.sync="showModalCreate" modal-classes="modal-lg">
            <h3 slot="header" class="modal-title" id="modal-title-default">
                {{ this.titlePopup }} Promoter Config
            </h3>
            <form @submit.prevent>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">
                                Brand Code
                            </label>
                            <model-list-select :list="brandCodeOption" v-model="watch_brand_code" option-value="value"
                                option-text="text" placeholder="select brand" :isDisabled="isBrandCodeDisabled">
                            </model-list-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <base-input alternative="" label="Promoter Code" input-classes="form-control"
                            v-model="promoterModel.promoter_code" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <base-input alternative="" label="Promoter Description" input-classes="form-control"
                            v-model="promoterModel.promoter_desc" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group has-label">
                            <label class="form-control-label"> Valid Start End Date </label>
                            <date-picker v-model="startEndDate" range editable clearable value-type="YYYY-MM-DD"
                                id="StartEndDate" :default-value="startEndDate" style="width: 100%"
                                :disabled="isDisabledUpdate"></date-picker>
                        </div>
                    </div>
                </div>
            </form>
            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="showModalCreate = false">Close/ Cancel
                </base-button>
                <button v-on:click="createUpdatePromoter" class="btn btn-primary" v-bind:disabled="disableButtonSubmit">
                    Submit
                </button>
            </template>
        </modal>
        <modal :show.sync="showModalImport" modal-classes="modal-md">
            <h3 slot="header" class="modal-title" id="modal-title-default">
                Import Promoter Config
            </h3>
            <form @submit.prevent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group has-label">
                            <label class="form-control-label">
                                Brand Code
                            </label>
                            <model-list-select :list="brandCodeOption" v-model="watch_brand_code" option-value="value"
                                option-text="text" placeholder="select brand" :isDisabled="isBrandCodeDisabled">
                            </model-list-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group has-label">
                            <label class="form-control-label">
                                Excel File
                            </label>
                            <base-input id="excelFile" input-classes="form-control text-white" type="file" @change="onFileChange($event)" />
                            <p class="pl-3 mt-n4" v-if="importPromoterModel.excelSourceFile != null"><small>{{ importPromoterModel.excelSourceFile.name }}</small></p>
                        </div>
                    </div>
                </div>
            </form>
            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="showModalImport = false">Close/ Cancel
                </base-button>
                <button v-on:click="importPromoter" class="btn btn-primary" :disabled="importPromoterModel.excelSourceFile == null">
                    Submit
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import "vue2-datepicker/index.css";

export default {
    name: "PromoterList",
    data() {
        return {
            is_allowed_create: false,
            showActionDelete: false,
            showActionEdit: false,
            brandCodeOption: [],
            watch_brand_code: "PHFortune",
            deleteMessages: [],
            message: null,
            showConfirmationModal: false,
            titlePopup: "Create",
            showModalCreate: false,
            isBrandCodeDisabled: false,
            showModalImport: false,
            promoterModel: {
                brand_code: "PHFortune",
                promoter_code: "",
                promoter_desc: "",
                valid_start_date: new Date().toISOString(),
                valid_end_date: new Date().toISOString(),
            },
            importPromoterModel: {
                brand_code: "PHFortune",
                excelSourceFile: null
            },
            isDisabledUpdate: false,
            startEndDate: [],
            selectedItems: [],
            rows: [],
            allPromoterConfigs: null,
            columns: [
                {
                    label: "ID",
                    name: "id",
                    slot_name: "action_button",
                },
                {
                    label: "Brand",
                    name: "brand_code",
                    sort: true,
                },
                {
                    label: "Promotor Code",
                    name: "promoter_code",
                    sort: true,
                },
                {
                    label: "Promotor Desc",
                    name: "promoter_desc",
                    sort: true,
                },
                {
                    label: "Valid Start Date",
                    name: "valid_start_date",
                    sort: true,
                },
                {
                    label: "Valid End Date",
                    name: "valid_end_date",
                    sort: true,
                },
            ],
            config: {
                pagination: true,
                pagination_info: true,
                num_of_visibile_pagination_buttons: 7,
                per_page: 10,
                checkbox_rows: true,
                highlight_row_hover: true,
                rows_selectable: true,
                multi_column_sort: false,
                card_mode: false,
                selected_rows_info: true,
                per_page_options: [5, 10, 20, 30],
            },
            classes: {
                table: "table-striped table-bordered",
                row: {
                    "my-row my-row2": true,
                    "function-class": function (row) {
                        return row.id == 1;
                    },
                },
            },
        };
    },
    created() {
        this.mappingRole();
        this.onRefreshData();
    },
    methods: {
        mappingRole() {
            let isChe = this.$store.getters.roleMappingData.some(object =>
                object.role.toLowerCase().includes('phche') &&
                object.menu.toLowerCase().includes('promoterconfig')
            );
            let isFortune = this.$store.getters.roleMappingData.some(object =>
                object.role.toLowerCase().includes('phft') ||
                object.role.toLowerCase().includes('fortune') &&
                object.menu.toLowerCase().includes('promoterconfig')
            );
            let isAdministrator = this.$store.getters.isLoginUserAdmin;
            this.brandCodeOption = [];
            if (isAdministrator || isChe)
            {
                this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
                this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
                this.is_allowed_create = true;
                this.watch_brand_code = "PHChe";
            }

            if (isAdministrator || isFortune)
            {
                this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
                this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
                this.is_allowed_create = true;
                this.watch_brand_code = "PHFortune";
            }
        },
        onSelectRow(payload) {
            //filter data payload, jika ada data payload yg seharusnya tidak ada dilist tapi masih ada
            payload.selected_items = payload.selected_items.filter(selectedItem => {
                return this.rows.some(row => row.id === selectedItem.id);
            });

            this.showActionEdit = true;
            this.showActionDelete = true;
            this.selectedItems = payload.selected_items;

            if (payload.selected_items.length == 0) {
                this.showActionEdit = false;
                this.showActionDelete = false;
            }
            if (payload.selected_items.length > 1) {
                this.showActionEdit = false;
            }
        },
        onEditRow() {
            this.promoterModel = this.allPromoterConfigs.filter(
                (x) => x.id === this.selectedItems[0].id
            )[0];
            let StartDate = this.promoterModel.valid_start_date;
            let EndDate = this.promoterModel.valid_end_date;
            //add 1 days below to avoid when update, the date move back by 1 days due to convertion to utc
            let momStart = this.$moment(new Date(StartDate)).add(1, 'days').format("YYYY-MM-DD");
            let momEnd = this.$moment(new Date(EndDate)).add(1, 'days').format("YYYY-MM-DD");
            this.startEndDate = [momStart, momEnd];
            this.isBrandCodeDisabled = true;
            this.showModalCreate = true;
            this.titlePopup = "Update";
        },
        resetMessage() {
            this.message = null;
            this.deleteMessages = [];
            this.selectedItems = [];
        },
        onCreateNewPromoter() {
            this.showModalCreate = true;
            this.titlePopup = "Create";
            this.isBrandCodeDisabled = false;
            this.onResetForm();
        },
        async onRefreshData() {
            api_loyalty
                .GetAllPromoter(this.watch_brand_code)
                .then((data) => {
                    try {
                        if(data.isSuccess){
                            this.rows = data.data;
                            this.allPromoterConfigs = data.data;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            this.watch_promo_type = "0";
        },
        onResetForm() {
            this.promoterModel = {
                brand_code: "PHFortune",
                promoter_code: "",
                promoter_desc: "",
                valid_start_date: new Date().toISOString(),
                valid_end_date: new Date().toISOString(),
            };
            this.isBrandCodeDisabled = false;
            let momNow = this.$moment(new Date().toUTCString());
            let StartDate = momNow.format("YYYY-MM-DD");
            let EndDate = momNow.add(1, "months").format("YYYY-MM-DD");
            let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");
            let momEnd = this.$moment(new Date(EndDate)).format("YYYY-MM-DD");
            this.startEndDate = [momStart, momEnd];
            this.isDisabledUpdate = false
        },
        async createUpdatePromoter() {
            if (this.startEndDate.length > 1) {
                this.promoterModel.valid_start_date = new Date(
                    this.startEndDate[0]
                ).toISOString();
                this.promoterModel.valid_end_date = new Date(
                    this.startEndDate[1]
                ).toISOString();
            }

            if (this.promoterModel.id) {
                this.promoterModel.modified_date_utc = new Date().toISOString();
                this.promoterModel.brand_code = this.watch_brand_code;

                api_loyalty
                    .UpdatePromoter(this.promoterModel.brand_code, this.promoterModel)
                    .then((response) => {
                        this.onRefreshData();
                        var popupType = "success"
                        if (response.isSuccess == false) {
                            popupType = "danger";
                        }

                        this.message = {
                            message: response.message,
                            type: popupType,
                        };
                    })
                    .catch((e) => {
                        console.log(e);
                        if (e.response && e.response.status === 401)
                        {
                            this.message = {
                                message: "You don't have a permission",
                                type: 'danger'
                            }
                        } else
                        {
                            this.message = {
                                message: "Failed to update Promoter Code.",
                                type: "danger",
                            }
                        }
                    });
            } else {
                this.promoterModel.brand_code = this.watch_brand_code;
                api_loyalty
                    .AddPromoter(this.promoterModel.brand_code, this.promoterModel)
                    .then((response) => {
                        this.onRefreshData();

                        var popupType = "success"
                        if (response.isSuccess == false) {
                            popupType = "danger";
                        }

                        this.message = {
                            message: response.message,
                            type: popupType,
                        };
                    })
                    .catch((e) => {
                        console.log(e);
                        if (e.response && e.response.status === 401)
                        {
                            this.message = {
                                message: "You don't have a permission",
                                type: 'danger'
                            }
                        } else
                        {
                            this.message = {
                                message: "Failed to create Promoter Code.",
                                type: "danger",
                            }
                        }
                    });
            }

            this.onResetForm();
            this.showModalCreate = false;
        },
        onDeleteRow() {
            this.selectedItems.forEach((element) => {
                let deleteRequest = {
                    id: element.id,
                };
                this.promoterModel.id = deleteRequest.id;
                this.promoterModel.brand_code = this.watch_brand_code;

                api_loyalty
                    .DeletePromoter(this.promoterModel.brand_code, this.promoterModel)
                    .then((response) => {
                        this.onRefreshData();

                        var popupType = "success"
                        if (response.isSuccess == false) {
                            popupType = "danger";
                        }

                        let msg = {
                            message:
                                response.message + " : " + element.promoter_code + "'.",
                            type: popupType,
                        };
                        this.deleteMessages.push(msg);
                    })
                    .catch((e) => {
                        console.log(e);
                        var msg = {
                            message:
                                "Failed to delete promoter '" +
                                element.promoter_code +
                                "'.",
                            type: "danger",
                        };

                        if (e.response && e.response.status === 401)
                        {
                            msg = {
                                message: "You don't have a permission",
                                type: 'danger'
                            }
                        }
                        this.deleteMessages.push(msg);
                    });
            });
            this.showConfirmationModal = false;
        },
        onImportPromoter(){
            this.onRisetFormImport();
            this.showModalImport = true;
        },
        onRisetFormImport(){
            this.importPromoterModel = {
                brand_code: "PHFortune",
                excelSourceFile: null
            };
        },
        async getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            this.importPromoterModel.excelSourceFile = files[0];
        },
        async importPromoter() {
            this.importPromoterModel.brand_code = this.watch_brand_code;
            //var base64String = this.getBase64(this.importPromoterModel.excelSourceFile)
            var base64String = "";
            await this.getBase64(this.importPromoterModel.excelSourceFile).then(
                data =>{
                    
                    base64String = data;
                }
            );

            console.log(base64String)
            api_loyalty
                    .ImportPromoter(this.importPromoterModel.brand_code, base64String)
                    .then((response) => {
                        this.onRefreshData();

                        var popupType = "success"
                        if (response.isSuccess == false) {
                            popupType = "danger";
                        }

                        this.message = {
                            message: response.message,
                            type: popupType,
                        };
                    })
                    .catch((e) => {
                        console.log(e);
                        this.message = {
                            message: "Failed to import Promoter Code.",
                            type: "danger",
                        };
                    });
            
            this.showModalImport = false;
            this.onRisetFormImport();
        },
    },
    components: {
        VueBootstrap4Table,
        ModelListSelect,
    },
    watch: {
        watch_brand_code: function () {
            this.promoterModel.brand_code = this.watch_brand_code;
            this.onRefreshData();
        },
    },
    computed: {
        disableButtonSubmit: function () {
            let isDisabled = false;
            if (this.promoterModel.brand_code &&
                this.promoterModel.promoter_code &&
                this.promoterModel.valid_start_date &&
                this.promoterModel.valid_end_date &&
                !this.isDisabledUpdate) {
                isDisabled = false;
            }
            else {
                isDisabled = true;
            }
            return isDisabled;
        },
    }
};
</script>